import React from "react";
import { Button, Table, Text } from "@deliverr/ui";
import { ManifestResponse } from "@deliverr/carrier-network-types";
import { format } from "date-fns";

interface EpostManifestTableProps {
  manifests: ManifestResponse[];
  downloadManifest: (manifest: ManifestResponse) => Promise<void>;
}

export const EpostManifestTable: React.FC<EpostManifestTableProps> = ({ manifests, downloadManifest }) => {
  return (
    <div>
      <Table
        headings={["Gaylord ID", "Merchant GUID", "Generated At", "Download"]}
        rows={manifests.map((manifest) => [
          <Text key={String(manifest.gaylordId)}>{manifest.gaylordId}</Text>,
          <Text key={String(manifest.merchantGuid)}>{manifest.merchantGuid}</Text>,
          <Text key={String(manifest.gaylordId) + String(manifest.merchantGuid) + "-date"}>
            {format(manifest.dispatchedAt, "MMMM dd, yyyy, h:mmaaa")}
          </Text>,
          <Button
            key={String(manifest?.gaylordId) + String(manifest?.merchantGuid) + "-btn"}
            onClick={async () => await downloadManifest(manifest)}
          >
            Download
          </Button>,
        ])}
        caption="Epost Manifests"
      />
    </div>
  );
};
